import { Injectable } from '@angular/core';
import * as L from 'leaflet';
import { GeoJsonPoint } from '../models/geo-json-point';

@Injectable({
  providedIn: 'root',
})
export class MarkerService {
  constructor() {}

  /**
   * Creates markers on the map from GeoJSON coordinate data.
   * @param map A leaflet map
   * @param point The GeoJSON coordinate object
   */
  renderMarker(map: L.Map, point: GeoJsonPoint): void {
    const lon = point.coordinates[0];
    const lat = point.coordinates[1];
    const marker = L.marker([lat, lon]);
    marker.addTo(map);
  }

  renderGeoJsonMarker(map: L.Map, point: GeoJsonPoint, popupContent?: any): void {
    const geoJSON = L.geoJSON(point).addTo(map);
    if (popupContent) {
      const htmlContent = `
        <p><b>${popupContent.title}</b></p>
        <p>${popupContent.body}</p>
      `;
      geoJSON.bindPopup(htmlContent).openPopup();
    }
  }
}
